"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.filterSelectFilter = filterSelectFilter;
exports.getSelectFilterParams = getSelectFilterParams;
exports.getSelectFilterParamsFromQuery = getSelectFilterParamsFromQuery;
exports.getSelectFilterQuery = getSelectFilterQuery;
exports.initializeFixedSelectFilterState = initializeFixedSelectFilterState;
exports.initializeMultiSelectState = initializeMultiSelectState;
exports.isSelectFilterStatePristine = isSelectFilterStatePristine;
exports.isSelectFilterStateUncommitted = isSelectFilterStateUncommitted;
exports.setSingleSelectState = setSingleSelectState;
exports.toggleMultiSelectState = toggleMultiSelectState;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _every2 = _interopRequireDefault(require("lodash/every"));
var _split2 = _interopRequireDefault(require("lodash/split"));
var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _filters = require("../../constants/filters.constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function isSelectFilterStateUncommitted(uncommittedState, state) {
  return (0, _filter2.default)(uncommittedState, ['selected', true]).length !== (0, _filter2.default)(state, ['selected', true]).length;
}
function isSelectFilterStatePristine(state) {
  return (0, _every2.default)(state, ['selected', false]);
}
function getSelectFilterParams(state) {
  return (0, _map2.default)((0, _filter2.default)(state, {
    selected: true
  }), function (_ref) {
    var code = _ref.code;
    return String(code);
  });
}
function getSelectFilterQuery(params, defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = undefined;
  }
  return params.join(_filters.FILTER_SEPARATOR_MAP.MULTI_SELECT) || defaultValue;
}
function getSelectFilterParamsFromQuery(query) {
  if (typeof query !== 'string' || query === _filters.FILTER_SPECIAL_MAP.SELECT_ALL) return [];
  return (0, _split2.default)(query, _filters.FILTER_SEPARATOR_MAP.MULTI_SELECT);
}
function setSingleSelectState(state, code) {
  return (0, _map2.default)(state, function (itemState) {
    var selected = String(itemState.code) === String(code);
    return _objectSpread(_objectSpread({}, itemState), {}, {
      selected: selected
    });
  });
}
function toggleMultiSelectState(state, codes) {
  return (0, _map2.default)(state, function (itemState) {
    return (0, _includes2.default)(codes, itemState.code) ? _objectSpread(_objectSpread({}, itemState), {}, {
      selected: !itemState.selected
    }) : itemState;
  });
}
function initializeMultiSelectState(filterData, labelFactory) {
  if (filterData === void 0) {
    filterData = [];
  }
  return (0, _map2.default)(filterData, function (code) {
    var state = {
      code: code,
      selected: false,
      label: undefined
    };
    if ((0, _isFunction2.default)(labelFactory)) {
      state.label = labelFactory(code);
    }
    return state;
  });
}
function initializeFixedSelectFilterState(staticData, availableData) {
  if (staticData === void 0) {
    staticData = [];
  }
  if (availableData === void 0) {
    availableData = [];
  }
  return (0, _map2.default)(staticData, function (code) {
    return {
      code: code,
      selected: false,
      isAvailable: (0, _includes2.default)(availableData, code)
    };
  });
}
function filterSelectFilter(filterParams, code) {
  return (0, _isEmpty2.default)(filterParams) || (0, _includes2.default)(filterParams, code);
}